/* ── Studio Phalsa — Featured Products JS ───────────────────── */
(function () {
  'use strict';

  /* ── IntersectionObserver: reveal cards on scroll ────────────── */
  const cards = document.querySelectorAll('.sp-product-card');
  if (!cards.length) return;

  const io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  cards.forEach(function (card) { io.observe(card); });

  /* ── Wishlist toggle ─────────────────────────────────────────── */
  document.querySelectorAll('.sp-product-card__wishlist').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const isLiked = btn.classList.toggle('is-liked');
      btn.setAttribute('aria-label', isLiked ? 'Remove from wishlist' : 'Add to wishlist');
    });
  });

  /* ── Add to cart ─────────────────────────────────────────────── */
  document.querySelectorAll('.sp-card__add-btn').forEach(function (btn) {
    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      e.stopPropagation();

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }]
          })
        });

        const data = await response.json();
        console.log('[SP] Cart add response:', data);

        if (!response.ok || data.status) {
          console.error('[SP] Cart add failed:', data);
          return;
        }

        // Fetch updated cart for item count + Horizon event payload
        const cart = await fetch('/cart.js', {
          headers: { 'Accept': 'application/json' }
        }).then(function (r) { return r.json(); });

        // Update cart badge
        const badge = document.querySelector('.sp-navbar__cart-badge');
        if (badge) badge.textContent = cart.item_count;

        // Dispatch Horizon's native cart:update event so the drawer auto-opens
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            data: { itemCount: cart.item_count }
          }
        }));

        // Fallback: directly click the cart button / call open()
        const cartBtn = document.querySelector('.sp-navbar__cart-btn');
        if (cartBtn) {
          cartBtn.click();
        } else {
          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        }

      } catch (err) {
        console.error('[SP] Add to cart error:', err);
      }
    });
  });

})();
